<template>
  <mark
    class="eventLabel"
    :style="{
      color: color,
      'background-color': hasIcon ? 'transparent' : bgColor,
      'font-size': fontSize,
      border: borderColor ? `1px solid ${borderColor}` : 'none',
    }"
    :class="{ 'eventLabel--disabled': disabled }"
  >
    <template v-if="hasIcon">
      <img :src="icon" />
    </template>
    <template v-else-if="small">
      <v-tooltip top content-class="eventLabel_tooltip ">
        <template #activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on"> {{ text.charAt(0) }}</span>
        </template>
        <h2>{{ text }}</h2>
      </v-tooltip>
    </template>
    <template v-else>
      {{ text }}
    </template>
  </mark>
</template>

<script>
import { getEvenLabelStyle } from '@/utils/helpers';
export default {
  name: 'EventLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      color: '',
      bgColor: '',
      fontSize: '',
      text: '',
      icon: null,
      borderColor: null,
    };
  },
  computed: {
    hasIcon() {
      return this.icon && this.isIcon;
    },
  },
  watch: {
    label(val) {
      this.handleStyle(val);
    },
  },
  mounted() {
    this.handleStyle(this.label);
  },
  methods: {
    handleStyle(val) {
      if (!val) {
        return;
      }
      const style = getEvenLabelStyle(val);
      this.color = style.color;
      this.icon = style.icon || null;
      this.bgColor = style.bgColor;
      this.fontSize = style.fontSize;
      this.text = style.text;
      this.borderColor = style.borderColor;
    },
  },
};
</script>
<style lang="scss">
.eventLabel {
  height: 19px;
  margin-top: 5px;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-color);
  display: inline-block;
  flex-grow: 0;
  width: fit-content;
  &--disabled {
    img {
      filter: grayscale(1);
      opacity: 0.3;
    }
  }

  &_tooltip {
    &.v-tooltip__content {
      padding: 2px 6px;
      border-radius: 6px;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
      opacity: 0;
      background-color: #666;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      &:after,
      &:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #666666;
        border-width: 5px;
        margin-left: -5px;
      }
      &:before {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #666666;
        border-width: 6px;
        margin-left: -6px;
      }
      &.menuable__content__active {
        opacity: 1 !important;
      }
    }
  }
}
</style>
